// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../Assets/images/accueil-Boutique-matching-plat.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-more-boutique {
    border: 2px solid #4AAE9B;
    background-color: #4AAE9B;
    color: #ffffff;
    padding: 10px 28px;
    font-size: 18px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
    border-radius: 40px;
    float: left;
    font-weight: "Lato";
    font-weight: 400;
  }
  .btn-more-boutique:hover{
   
        background-color: #A8C9B0;
        color: #ffffff;
        border: 2px solid #A8C9B0;
      cursor: pointer;
  }
  .div-more-boutique{
    padding-top: 20px;
  }
  .bg-section-1{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    padding: 7% 13%;
    text-align: left;
    background-size: cover;
    /*margin-top: 6%;*/
  }
 
  .title-class-icon{
    padding-bottom: 30px;
  }
  @media (min-width: 1090px) {
    .bg-section-3-mobile{
      display: none;
    }
    .responsive {
      width: 100%;
      height: auto;
    }
    .bg-section-1{
      padding: 9% 15%;
    }
  }
  @media (max-width: 1089px) {
    .bg-section-1 {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    padding: 100px 30px;
    background-size: cover;

  }
  .bg-section-2{
   display: none;
  }
  .center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 60% !important;
}
.div-more{
  padding-top: 10px;
}
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/OffersOverview/OffersOverview.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,6CAA6C;IAC7C,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;;QAEM,yBAAyB;QACzB,cAAc;QACd,yBAAyB;MAC3B,eAAe;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,yDAAmF;IACnF,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;EACA;IACE;MACE,aAAa;IACf;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,yDAAmF;IACrF,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;;EAExB;EACA;GACC,aAAa;EACd;EACA;EACA,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;EACE","sourcesContent":[".btn-more-boutique {\n    border: 2px solid #4AAE9B;\n    background-color: #4AAE9B;\n    color: #ffffff;\n    padding: 10px 28px;\n    font-size: 18px;\n    cursor: pointer;\n    transition: background-color 0.3s ease-in-out;\n    border-radius: 40px;\n    float: left;\n    font-weight: \"Lato\";\n    font-weight: 400;\n  }\n  .btn-more-boutique:hover{\n   \n        background-color: #A8C9B0;\n        color: #ffffff;\n        border: 2px solid #A8C9B0;\n      cursor: pointer;\n  }\n  .div-more-boutique{\n    padding-top: 20px;\n  }\n  .bg-section-1{\n    background-image: url(../../../../Assets/images/accueil-Boutique-matching-plat.jpg);\n    background-repeat: no-repeat;\n    background-position: center;\n    padding: 7% 13%;\n    text-align: left;\n    background-size: cover;\n    /*margin-top: 6%;*/\n  }\n \n  .title-class-icon{\n    padding-bottom: 30px;\n  }\n  @media (min-width: 1090px) {\n    .bg-section-3-mobile{\n      display: none;\n    }\n    .responsive {\n      width: 100%;\n      height: auto;\n    }\n    .bg-section-1{\n      padding: 9% 15%;\n    }\n  }\n  @media (max-width: 1089px) {\n    .bg-section-1 {\n      background-image: url(../../../../Assets/images/accueil-Boutique-matching-plat.jpg);\n    background-repeat: no-repeat;\n    background-position: center;\n    padding: 100px 30px;\n    background-size: cover;\n\n  }\n  .bg-section-2{\n   display: none;\n  }\n  .center {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 60% !important;\n}\n.div-more{\n  padding-top: 10px;\n}\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
